export const CONFIGURE_SELECTOR = 'workflow-configure-selector';

export const RULES_SELECTOR = 'workflow-rules-selector';

export const FILES_SELECTOR = 'workflow-files-selector';

export const GUIDE_STEPS = [
  {
    selector: CONFIGURE_SELECTOR,
    title: 'configureLeadStages',
    description: 'configureLeadStagesDescription',
  },
  {
    selector: RULES_SELECTOR,
    title: 'setStageRules',
    description: 'setStageRulesDescription',
  },
  {
    selector: FILES_SELECTOR,
    title: 'pickStageFiles',
    description: 'pickStageFilesDescription',
  },
];
